import { render, staticRenderFns } from "./ListStock.vue?vue&type=template&id=c2faac3e"
import script from "./ListStock.vue?vue&type=script&lang=js"
export * from "./ListStock.vue?vue&type=script&lang=js"
import style0 from "./ListStock.vue?vue&type=style&index=0&id=c2faac3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports